import { registerPlugin } from '@capacitor/core';
const ForegroundService = registerPlugin('ForegroundService');
export * from './definitions';
export { ForegroundService };
//# sourceMappingURL=index.js.map